import { UserStatusEnum } from 'common/constants/enum';
import CustomerSnackBar from 'legacy-modules/sales/component/customer-snack-bar';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext, useWatch } from 'react-hook-form';

//isolated component
export default function AgentSupendToast() {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const [agentStatus, isExceedingQuota] = useWatch({
    control,
    name: ['agentStatus', 'isExceedingQuota'],
  });

  return (
    <>
      {agentStatus === UserStatusEnum.UnderSurveillance && (
        <CustomerSnackBar text={t('common:agent_suspend_message')} />
      )}
      {isExceedingQuota && (
        <CustomerSnackBar
          text={t('common:agent_limited_transaction_message')}
        />
      )}
    </>
  );
}
